export default [
  {
    path: '/auth',
    component: () => import(/* webpackChunkName: "auth" */ '@/layouts/Auth.vue'),
    children: [
      {
        name: 'Register',
        path: 'register',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/Register.vue')
      },
      {
        name: 'Login',
        path: 'login',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/Login.vue')
      },
      {
        name: 'ForgotPassword',
        path: 'forgot-password',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ForgotPassword.vue')
      },
      {
        name: 'ResetPassword',
        path: 'reset-password',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ResetPassword.vue')
      },
      {
        name: 'Token',
        path: 'token/:token',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/Token.vue')
      }
    ]
  }
]